module.exports = __webpack_public_path__ + "img/image121.2bdbb299.png";